const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const cores = navigator.hardwareConcurrency || 4, mem = navigator.deviceMemory || 4;
const LOW = cores <= 4 || mem <= 2;
function initTabs() {
const viewer = document.querySelector(".mw-viewer"), stage = viewer?.querySelector(".mw-stage");
if (!viewer) return;
const tabs = [...viewer.querySelectorAll("[data-mw-tab]")];
let started = false;
const show = (which) => {
viewer.dataset.view = which;
tabs.forEach((t) => { const on = t.dataset.mwTab === which; t.classList.toggle("is-on", on); t.setAttribute("aria-selected", on); });
if (which === "3d" && started) requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
if (which === "3d" && !started && stage) {
started = true;
const fb = stage.querySelector(".mw-stage-fallback"); if (fb) fb.textContent = "Loading 3D model…";
import(stage.dataset.viewer).catch(() => { if (fb) fb.textContent = "3D view could not load. Check your connection."; started = false; });
}
};
tabs.forEach((t) => t.addEventListener("click", () => show(t.dataset.mwTab)));
if (stage && tabs.length) show("3d");
const slides = viewer.querySelector(".mw-slides"), dots = [...viewer.querySelectorAll(".mw-dot")];
if (slides && dots.length) slides.addEventListener("scroll", () => {
const k = Math.round(slides.scrollLeft / slides.clientWidth);
dots.forEach((d, n) => d.classList.toggle("is-on", n === k));
}, { passive: true });
}
function initPage() {
const qtyIn = document.getElementById("mw-qty");
document.querySelectorAll("[data-mw-step]").forEach((b) => b.addEventListener("click", () => {
qtyIn.value = Math.max(1, Math.min(20, (parseInt(qtyIn.value, 10) || 1) + Number(b.dataset.mwStep)));
}));
document.querySelectorAll(".mw-faq details").forEach((d) => {
d.querySelector("summary").addEventListener("click", () => { document.querySelectorAll(".mw-faq details[open]").forEach((o) => { if (o !== d) o.open = false; }); });
});
const bar = document.querySelector(".mw-bar"), form = document.getElementById("mw-order");
if (bar && form && "IntersectionObserver" in window) {
let top = false, atForm = false;
const upd = () => bar.classList.toggle("is-on", top && !atForm);
const sentinel = document.querySelector(".mw-buy");
new IntersectionObserver(([en]) => { top = !en.isIntersecting && en.boundingClientRect.top < 0; upd(); }).observe(sentinel);
new IntersectionObserver(([en]) => { atForm = en.isIntersecting; upd(); }, { threshold: .1 }).observe(form);
}
document.querySelectorAll('a[href^="#"]').forEach((a) => a.addEventListener("click", (e) => {
const t = document.querySelector(a.getAttribute("href"));
if (!t) return; e.preventDefault();
t.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
}));
}
function initLightbox() {
const imgs = [...document.querySelectorAll("[data-mw-photo]")];
if (!imgs.length) return;
const srcs = [...new Set(imgs.map((el) => el.dataset.mwPhoto))];
const box = document.createElement("div");
box.className = "mw-lightbox"; box.hidden = true;
box.setAttribute("role", "dialog"); box.setAttribute("aria-label", "Product photos");
const pic = document.createElement("img"); pic.alt = "";
const mk = (cls, label, txt) => { const b = document.createElement("button"); b.type = "button"; b.className = "mw-icon-btn " + cls; b.setAttribute("aria-label", label); b.textContent = txt; return b; };
const close = mk("mw-lb-close", "Close", "✕"), prev = mk("mw-lb-prev", "Previous photo", "←"), next = mk("mw-lb-next", "Next photo", "→");
const count = document.createElement("div"); count.className = "mw-lb-count";
box.append(pic, close, prev, next, count);
document.querySelector(".mw").appendChild(box);
let i = 0;
const show = (k) => { i = (k + srcs.length) % srcs.length; pic.src = srcs[i]; count.textContent = `${i + 1} / ${srcs.length}`; };
const open = (src) => { show(Math.max(0, srcs.indexOf(src))); box.hidden = false; requestAnimationFrame(() => box.classList.add("is-on")); document.documentElement.style.overflow = "hidden"; close.focus(); };
const shut = () => { box.classList.remove("is-on"); document.documentElement.style.overflow = ""; setTimeout(() => { box.hidden = true; }, reduce ? 0 : 300); };
imgs.forEach((el) => el.addEventListener("click", () => open(el.dataset.mwPhoto)));
close.addEventListener("click", shut);
prev.addEventListener("click", () => show(i - 1));
next.addEventListener("click", () => show(i + 1));
box.addEventListener("click", (e) => { if (e.target === box) shut(); });
document.addEventListener("keydown", (e) => {
if (box.hidden) return;
if (e.key === "Escape") shut(); else if (e.key === "ArrowLeft") show(i - 1); else if (e.key === "ArrowRight") show(i + 1);
});
let sx = null;
box.addEventListener("touchstart", (e) => { sx = e.touches[0].clientX; }, { passive: true });
box.addEventListener("touchend", (e) => { if (sx === null) return; const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1)); sx = null; });
}
initTabs();
initPage();
initLightbox();
